/** Énumération des types pour le champ à traiter avant le */
export enum TypeTraiterAvantLe {
	AUCUN = 'AUCUN',
	DATE_DU_JOUR = 'DATE_DU_JOUR',
	DATE_DEBUT_MISSION = 'DATE_DEBUT_MISSION',
	VEILLE_DEBUT_MISSION = 'VEILLE_DEBUT_MISSION'
}
